// extracted by mini-css-extract-plugin
export default {"status":"_5ddb06b29ec60568","counter":"c7e5bec6d99c7fd8","failed":"_025083eb56fc36af","failedTitle":"c4a05013e9a8bee3","failedList":"fc7fa7d372d2896f"};